import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { BaseAuthService } from '@stillmandigital/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseAuthService {
  private readonly _router = inject(Router);

  protected userTokenKey = 'HURON.USER_TOKEN_KEY';

  public loginUrl = 'login';

  public override logOut() {
    Sentry.setUser(null);
    super.logOut();
  }

  protected navigateTo(url: string, refresh = false) {
    this._router.navigateByUrl(url).then(() => {
      if (refresh) {
        window.location.reload();
      }
    });
  }
}
